// extracted by mini-css-extract-plugin
export default {"headerBar":"NewQuestion_headerBar__Qgr-m"};